import { DataSource, TextboxProps } from "@mcleod/components";
import { LMECompanySettings } from "./settings/LMECompanySettings";
import { ModelRow } from "@mcleod/core";

export class AssetUtil {
    public static isAssetMoveType(source: DataSource | ModelRow | boolean) {
        let defaultMoveType: string;
        if (source instanceof DataSource) {
            if (source.activeRow) {
                defaultMoveType = source.activeRow.get("def_move_type", null);
            }
        }
        else if (source instanceof ModelRow) {
            defaultMoveType = source.get("def_move_type", null);
        }
        else if (typeof source === "boolean") {
            defaultMoveType = source ? "A" : "B";
        }

        if (!defaultMoveType) {
            defaultMoveType = LMECompanySettings.get().default_move_type;
        }
        return defaultMoveType === "A";
    }

    public static getDriverLookupModelProps(): Partial<TextboxProps> {
        return {
            lookupModel: "lme/dispatch/asset/driver-only",
            lookupModelLayout: "lme/dispatch/asset/DriverLookup",
            lookupModelResultField: "id",
            lookupModelDisplayField: "full_name"
        }
    }
}
